/**
 * GoogleMark — the four-colour Google "G", ported from the OnFlow Design
 * System project (components/navigation/Icon.jsx).
 */
import type { CSSProperties } from 'react';

interface GoogleMarkProps {
  size?: number;
  style?: CSSProperties;
}

export function GoogleMark({ size = 18, style }: GoogleMarkProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" aria-hidden="true" style={style}>
      <path
        fill="#EA4335"
        d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46 1.08 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z"
      />
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.74-.07-1.45-.19-2.13H9v4.03h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.71-1.57 2.68-3.89 2.68-6.88z"
      />
      <path
        fill="#FBBC05"
        d="M3.88 10.78a5.54 5.54 0 0 1-.29-1.78c0-.62.11-1.22.29-1.78V4.96H.96A8.99 8.99 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.38 0-4.4-1.57-5.13-3.74L.96 13.04A8.99 8.99 0 0 0 9 18z"
      />
    </svg>
  );
}
